<template>
  <div>
    <vs-popup :active.sync="primary" title="Create Attachment">
      <div class="grid grid-cols-2 gap-4 py-1">
        <vx-card class="cursor-pointer" @click="openCreate('external')">
          <div class="flex justify-center items-center">
            <feather-icon icon="GlobeIcon" svgClasses="h-8 w-8 mr-1"/>
            <h1 class="font-light ml-1">External URL</h1>
          </div>
        </vx-card>
        <vx-card class="cursor-pointer" @click="openCreate('internal')">
          <div class="flex justify-center items-center">
            <feather-icon icon="LinkIcon" svgClasses="h-8 w-8 mr-1"/>
            <h1 class="font-light ml-1">Internal URL</h1>
          </div>
        </vx-card>
        <!---
        <vx-card class="cursor-pointer" @click="openCreate('simulation')">
          <div class="flex justify-center items-center">
            <feather-icon icon="CodesandboxIcon" svgClasses="h-8 w-8 mr-1"/>
            <h1 class="font-light ml-1">Simulation</h1>
          </div>
        </vx-card>
        <vx-card class="cursor-pointer" @click="openCreate('flashcard')">
          <div class="flex justify-center items-center">
            <feather-icon icon="FileTextIcon" svgClasses="h-8 w-8 mr-1"/>
            <h1 class="font-light ml-1">FlashCard</h1>
          </div>
        </vx-card>
        --->
      </div>
    </vs-popup>
    <vs-popup :active.sync="create.external" title="Create External URL Attachment">
      <div class="popup-input">

        <div class="mb-3">
          <p class="mb-1 font-semibold">URL</p>
          <vs-input v-model="attachment.path" name="External Path" class="w-full" v-validate="'required|url'"/>
          <span class="text-danger text-sm font-bold">{{ errors.first('External Path') }}</span>
        </div>

        <div class="mb-3">
          <p class="mb-1 font-semibold">Title</p>
          <vs-input v-model="attachment.title" name="External Title" class="w-full" v-validate="'required'"/>
          <span class="text-danger text-sm font-bold">{{ errors.first('External Title') }}</span>
        </div>


        <p class="mb-1 font-semibold">Description <span class="font-light cursor-pointer" @click="custom.description = !custom.description">- Custom</span></p>
        <vs-input v-model="attachment.description" v-if="custom.description" class="mb-3 w-full"/>
        <div class="flex items-center mb-3" v-else>
          <vs-radio v-for="(description, index) in descriptionOptions.external" :key="index" v-model="attachment.description"
                    :vs-value="description" vs-name="attachmentDescriptionExternal" class="mr-3 p-2 font-bold rounded-lg input-bg">
            {{description}}
          </vs-radio>
        </div>

        <p class="mb-1 font-semibold">Icon <span class="font-light cursor-pointer" @click="custom.icon = !custom.icon">- Custom</span></p>
        <vs-input v-model="attachment.icon" v-if="custom.icon" class="mb-5 w-full"/>
        <div class="flex items-center mb-5" v-else>
          <vs-radio v-for="(icon, index) in iconOptions.external" :key="index" v-model="attachment.icon"
                    :vs-value="icon" vs-name="attachmentIconExternal" class="mr-3 p-2 font-bold rounded-lg input-bg">
            <feather-icon :icon="icon" svgClasses="h-5 w-5"/>
          </vs-radio>
        </div>

        <div class="flex items-center mb-2">
          <feather-icon icon="InfoIcon" svgClasses="h-7 w-7 mr-1"/>
          <h5 class="ml-1 font-light">An External URL Will Open In A New Tab</h5>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="create.internal" title="Create Internal URL Attachment">
      <div class="popup-input">

        <div class="mb-3">
          <p class="mb-1 font-semibold">App <span class="font-light cursor-pointer" @click="custom.app = !custom.app;">- Custom</span></p>
          <div class="flex items-center" v-if="!custom.app">
            <vs-radio v-for="(app, index) in internalUrls" :key="index" v-model="attachment.path" @input="setExternalApp(app)"
                      :vs-value="app.path" vs-name="attachmentAppInternal" class="mr-3 p-2 font-bold rounded-lg input-bg">
              {{app.title}}
            </vs-radio>
          </div>
        </div>

        <div v-if="custom.app">
          <div class="mb-3">
            <p class="mb-1 font-semibold">URL</p>
            <vs-input v-model="attachment.path"  name="Internal Path" class="w-full"/>
            <span class="text-danger text-sm font-bold">{{ errors.first('Internal Path') }}</span>
          </div>

          <div class="mb-3">
            <p class="mb-1 font-semibold">Title</p>
            <vs-input v-model="attachment.title"  name="Internal Title" class="w-full"/>
            <span class="text-danger text-sm font-bold">{{ errors.first('Internal Title') }}</span>
          </div>
        </div>

        <p class="mb-1 font-semibold">Description <span class="font-light cursor-pointer" @click="custom.description = !custom.description">- Custom</span></p>
        <vs-input v-model="attachment.description" v-if="custom.description" class="mb-3 w-full"/>
        <div class="flex items-center mb-3" v-else>
          <vs-radio v-for="(description, index) in descriptionOptions.internal" :key="index" v-model="attachment.description"
                    :vs-value="description" vs-name="attachmentDescriptionInternal" class="mr-3 p-2 font-bold rounded-lg input-bg">
            {{description}}
          </vs-radio>
        </div>

        <p class="mb-1 font-semibold">Icon <span class="font-light cursor-pointer" @click="custom.icon = !custom.icon">- Custom</span></p>
        <vs-input v-model="attachment.icon" v-if="custom.icon" class="mb-5 w-full"/>
        <div class="flex items-center mb-5" v-else>
          <vs-radio v-for="(icon, index) in iconOptions.internal" :key="index" v-model="attachment.icon"
                    :vs-value="icon" vs-name="attachmentIconInternal" class="mr-3 p-2 font-bold rounded-lg input-bg">
            <feather-icon :icon="icon" svgClasses="h-5 w-5"/>
          </vs-radio>
        </div>

        <div class="flex items-center mb-2">
          <feather-icon icon="InfoIcon" svgClasses="h-7 w-7 mr-1"/>
          <h5 class="ml-1 font-light">An Internal URL Will Use A Router Transition</h5>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'ClassroomAttachmentCreate',
  data () {
    return {
      attachment: {
        title: null,
        description: null,
        image: null,
        icon: null,
        type: null,
        path: null
      },
      create: {
        external: false,
        internal: false,
        simulation: false,
        flashcard: false
      },
      custom: {
        app: false,
        path: false,
        title: false,
        description: false,
        icon: false
      },
      descriptionOptions: {
        external : ['URL', 'Page', 'Folder', 'File', 'Video', 'Meeting'],
        internal: ['Page', 'App']
      },
      iconOptions: {
        external: ['GlobeIcon', 'LinkIcon', 'FolderIcon', 'FileIcon', 'FileTextIcon', 'VideoIcon', 'FilmIcon', 'YoutubeIcon'],
        internal: ['LinkIcon', 'HomeIcon', 'GridIcon', 'BookIcon']
      },
      internalUrls: [
        {path: '/dashboard', title: 'Dashboard', description: 'App', icon: 'HomeIcon'},
        {path: '/apps', title: 'Apps', description: 'App', icon: 'GridIcon'},
        {path: '/courses', title: 'Courses', description: 'App', icon: 'BookIcon'}
      ],

      primary: false
    }
  },
  methods: {
    openCreate (type) {
      if (!type) return
      this.setDefaults(type)
      this.primary = false
      this.create[type] = true
    },
    setDefaults (type) {
      if (!type) return
      if (type === 'external') {
        this.attachment.description = 'URL'
        this.attachment.icon = 'GlobeIcon'
      }
      if (type === 'internal') {
        this.attachment.description = 'Page'
        this.attachment.icon = 'LinkIcon'
      }
    },
    setExternalApp (app) {
      this.attachment.title = app.title
      this.attachment.icon = app.icon
      this.attachment.description = app.description
    }
  },
  props: {
    color: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
